import { useState, useEffect } from 'react'
import '../styles/components/theme-toggle.css'

function ThemeToggle() {
  const [theme, setTheme] = useState('dark')

  useEffect(() => {
    // Load theme from localStorage or default to dark
    const savedTheme = localStorage.getItem('parkort_theme') || 'dark'
    setTheme(savedTheme)
    document.documentElement.setAttribute('data-theme', savedTheme)
  }, [])

  const toggleTheme = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark'
    setTheme(newTheme)
    localStorage.setItem('parkort_theme', newTheme)
    document.documentElement.setAttribute('data-theme', newTheme)
  }

  return (
    <button
      className="theme-toggle"
      onClick={toggleTheme}
      aria-label={`Skift til ${theme === 'dark' ? 'lyst' : 'mørkt'} tema`}
      title={`Skift til ${theme === 'dark' ? 'lyst' : 'mørkt'} tema`}
    >
      {theme === 'dark' ? '☀️' : '🌙'}
    </button>
  )
}

export default ThemeToggle
